import { render } from "./PreOrders.vue?vue&type=template&id=5a39a9f8&scoped=true"
import script from "./PreOrders.vue?vue&type=script&lang=js"
export * from "./PreOrders.vue?vue&type=script&lang=js"

import "./PreOrders.vue?vue&type=style&index=0&id=5a39a9f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a39a9f8"]])

export default __exports__